module.exports = __webpack_public_path__ + "img/section2Logo7New.e2a2c88e.png";